import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';

import ChassisDetailPartListTable from './detail-tabs/ChassisDetailPartListTable';
import ChassisDetailLaborCatalogTable from './detail-tabs/ChassisDetailLaborCatalogTable'
import ChassisDetailOtherCostTable from './detail-tabs/ChasisDetailOtherCatalogTable';

import { useLanguage } from '../../../../../../contexts/LanguageContext';
import { useGetChassisItemsQuery, useGetChassisLaborQuery, useGetWarrantyClaimsByIdQuery,useGetChassisOtherCostQuery } from '../../../../../../api/endpoints/warrantyClaims';

const ChassisDetailTabs = ({ visible, onHide, id }) => {

    const { t, th, getCurrentLanguageId } = useLanguage();
    const [activeDetailIndex, setActiveDetailIndex] = useState(0);
    const { data: itemsRes, isFetching: itemsLoading } = useGetChassisItemsQuery(
        { Id: id, PageSize: 1000, PageNumber: 1, LanguageId: getCurrentLanguageId() },
        { skip: !id }
    );
    const { data: laborsRes, isFetching: laborsLoading } = useGetChassisLaborQuery(
        { Id: id, PageSize: 1000, PageNumber: 1, LanguageId: getCurrentLanguageId() },
        { skip: !id }
    );

     const { data: otherCostRes, isFetching: otherCostLoading } = useGetChassisOtherCostQuery(
        { Id: id, PageSize: 1000, PageNumber: 1, LanguageId: getCurrentLanguageId() },
        { skip: !id }
    );

    const { data: claimsRes, isFetching: claimsLoading } = useGetWarrantyClaimsByIdQuery(
        { id, languageId: getCurrentLanguageId() },
        { skip: !id }
    );

    const failureDate = claimsRes?.failureDate;
    const repairKm = claimsRes?.repairKm;
    const items = itemsRes?.data?.items ?? [];
    const labors = laborsRes?.data?.items ?? [];
    const otherCost = otherCostRes?.data?.items ?? [];

    const tabLabels = [
        { label: th('warrantyClaims.warrantyClaimsDetailTabs.partList'), icon: 'pi pi-cog', count: items.length },
        { label: th('warrantyClaims.warrantyClaimsDetailTabs.laborCatalog'), icon: 'pi pi-users', count: labors.length },
        {label: th('warrantyClaims.warrantyClaimsDetailTabs.otherCosts'), icon: 'pi pi-wallet', count: otherCost.length}
    ];

    return (
        <Dialog
            visible={visible}
            header={`${t('warranty.customerDeclaration.No')} – ${id ?? ''}`}
            modal
            onHide={onHide}
            style={{ width: '80vw', maxWidth: 1100 }}
        >
            <TabView activeIndex={activeDetailIndex} onTabChange={(e) => setActiveDetailIndex(e.index)} className="w-full h-full">
                {tabLabels.map((tab, index) => (
                    <TabPanel
                        key={index}
                        header={
                            <span className="tab-header">
                                <i className={`${tab.icon} mr-2`} />
                                {tab.label}
                                {tab.count > 0 && <span className="ml-2 px-2 py-1 border-round text-xs font-semibold bg-blue-100 text-blue-800">{tab.count}</span>}
                            </span>
                        }
                        className="w-full h-full"
                    >
                        {index === 0 && (
                            <ChassisDetailPartListTable
                                rows={items}
                                loading={itemsLoading || claimsLoading}
                                failureDate={failureDate}
                                repairKm={repairKm}
                            />
                        )}
                        {index === 1 && <ChassisDetailLaborCatalogTable rows={labors} loading={laborsLoading} />}
                        {index === 2 && <ChassisDetailOtherCostTable rows={otherCost} loading={otherCostLoading} />}

                    </TabPanel>
                ))}
            </TabView>
        </Dialog>
    );
};

export default ChassisDetailTabs;